export default __webpack_public_path__ + "static/media/Mulish-Bold.14efde3c.ttf";